
import {map} from 'rxjs/operators';
///<summary>
///  Cria provider para variavel global
///  class para receber variavies globais a serem compartilhadas
///  a responsabilidade da classe é tratar os dados globais que serão carregados do config.json
///</summary>
import { Injectable, Input, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { Subject ,  BehaviorSubject } from 'rxjs';
//import {StorageService} from './storage.service'

@Injectable()
export class Globals {
    configJson: any = { "loaded": false };
    private _login: any = {};
    private observable: Observable<any>;
    private subject = new BehaviorSubject<any>({})//;"logado":false,"codigo":"","nome":"", "filial":0});

    private subjectUser = new BehaviorSubject<any>({})//;"logado":false,"codigo":"","nome":"", "filial":0});
    mapUser = this.subjectUser.asObservable();

    server: any = { port: window.localStorage.getItem("porta") || 8886, host :window.localStorage.getItem("host") || 'http://localhost' };
    config: any = { filial: window.localStorage.getItem("filial") || 1 };



    load() {
        this.subscribe(x => {
        });
    }

    constructor(private http: HttpClient) {
        //, /*private rest: ODataProviderService, private oData: ODataBrProvider*/) {
        this.configJson.loaded = false;
    }

    private init() {
        /* if (this.oData !== null) {
             this.oData.port(this.server.port);
         }*/
    }

    notifyUser(x) {
        this.subjectUser.next(x);
    }
    @Input()
    get logado(): boolean {
        return this.login.logado;
    }
    set logado(x: boolean) {
        this._login.logado = x;
        this.notifyUser(this._login);
    }
    @Input()
    get usuarioCorrente() {
        return this.login.codigo;
    }
    set usuarioCorrente(x: string) {
        this._login.codigo = x;
        this.notifyUser(this._login);
    }
    @Input()
    get filialCorrente() {
        return this.login.filial;
    }
    set filialCorrente(x: number) {
        this.login.filial = x;
        this.notifyUser(this._login);
    }
    @Input()
    get idLogin() {
        return this.login.idLogin;
    }
    set idLogin(x: string) {
        this.login.idLogin = x;
        this.notifyUser(this._login);
    }
    @Input()
    get login() {
        return this._login;
    }
    set login(x) {
        this._login = x;
        this.notifyUser(this._login);
    }

    subscribe(proc: any = null): Observable<any> {
        if (this.configJson.loaded) {
            if (proc !== null) {
                this.init();
                proc(this.configJson);
            }
            return this.observable;
        }

        let rt = this.http.get('assets/config.json').pipe(
            map(js => {
                return js;
            }));

        this.observable = rt;

        this.configJson.loaded = true;


        if (proc != null) {
            rt.subscribe(r => {
                this.configJson = r;
                this.configJson.loaded = true;
                this.server = this.configJson.server;
                this.config = this.configJson.config;
                this.init();
                proc(r);
            },(error) => { this.errorProc(error);  proc(this.configJson)  })
        }
        return rt;
    }
    errorProc(erro)
    {  
        this.configJson = {  server : this.server, config : this.config  };  
        this.configJson.loaded = true;
    }

    /// variaveis
    public menuVisible: boolean = true;

    /// notifica os assinantes
    notify(message: string) {
        this.subject.next({ text: message });
    }
    /// notifica assinantes sem mensagem
    clearNotify() {
        this.subject.next(null);
    }

    /// obtem a objeto para assinar
    asObservable(): Observable<any> {
        return this.subject.asObservable();
    }

}


